import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaWhatsapp } from "react-icons/fa";

export default function SendWhatsAppNode({ data, selected }) {
  return (
    <div className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[220px] transition-shadow ${selected ? "border-green-500 shadow-md" : "border-surface-border"}`}>
      <Handle type="target" position={Position.Top} className="!w-3 !h-3 !bg-green-500 !border-2 !border-white" />
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px]" style={{ background: "linear-gradient(135deg, #16a34a, #22c55e)" }}>
        <FaWhatsapp size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Send WhatsApp</span>
      </div>
      <div className="px-3 py-2.5">
        {data.message ? (
          <p className="text-xs text-ink-muted line-clamp-2">{data.message}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Configure message...</p>
        )}
        {data.to && <p className="text-2xs text-ink-faint mt-1">To: {data.to}</p>}
      </div>
      <Handle type="source" position={Position.Bottom} className="!w-3 !h-3 !bg-green-500 !border-2 !border-white" />
    </div>
  );
}
